import store from './redux'
import getSymbolFromCurrency from 'currency-symbol-map'
import { getSubscriptionPlans } from "~/redux/user/subscription"

export default {
  error: platform => store.dispatch({'type': 'error', 'args': platform}),
  createSubscription: i => store.dispatch({ type: 'createSubscription', args: { selected: i } }),
  login: _ => store.dispatch({ 'type': 'login' }),
  updateProfile: _ => store.dispatch({ 'type': 'updateProfile' }),
  changePassword: _ => store.dispatch({ 'type': 'changePassword' }),
  manageDevices: devices  => store.dispatch({ 'type': 'manageDevices', 'args': devices }),
  forgotPassword: hardwall => store.dispatch({ 'type': 'forgotPassword', 'args': hardwall }),
  cancelSubscription: _ => store.dispatch({ 'type': 'cancelSubscription' }),
  upgradeSubscription: _ => store.dispatch({ 'type': 'upgradeSubscription' }),
  updateStripePayment: _ => store.dispatch({ 'type': 'updateStripePayment' }),
  billingHistory: _ => store.dispatch({ 'type': 'billingHistory' }),
  notice: _ => store.dispatch({ 'type': 'notice' }),
  episodeOverlay: episode =>store.dispatch({type: 'EpisodeOverlay', 'args': episode}),
  search: _ => store.dispatch({ 'type': 'search' }),
  hide: _ => store.dispatch({ 'type': 'hide' }),
  purchase: (plan, content, fn, purchase) => store.dispatch({ 'type': 'purchase', args: { plan, content, fn, purchase } }),
  equipment: _ => store.dispatch({'type': 'equipment'}),
  getSubscriptionPlans: _ => getSubscriptionPlans(),
  getSymbolFromCurrency: (sbl) => getSymbolFromCurrency(sbl),
  customOverlay: ({showCloseButton, renderContent}) => store.dispatch({'type': 'customOverlay', args: { showCloseButton, renderContent}}),
  searchList: _ => store.dispatch({ 'type': 'searchList' }),
  fitnessOnboardingScreen:({showCloseButton}) => store.dispatch({ type: 'fitnessOnboardingScreen', args: {showCloseButton}}),
  fitnessSignInCreate: ({showCloseButton, currentScreen}) => store.dispatch({ type: 'fitnessSignInCreate', args: {showCloseButton, currentScreen} }),
  fitnessChooseAPlan: ({showCloseButton}) => store.dispatch({ type: 'fitnessChooseAPlan', args: {showCloseButton} }),
  fitnessCheckout:({showCloseButton, selectedPlan}) => store.dispatch({ type: 'fitnessCheckout', args: {showCloseButton, selectedPlan}}),
  fitnessSetupProfile:({showCloseButton}) => store.dispatch({ type: 'fitnessSetupProfile', args: {showCloseButton}})
}